import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {LoginService} from 'src/app/core/services/login-service';
import {ToggleAppTheme, ToggleSidebar} from '../../../core/store/shared/shared.actions';
import {SharedState} from '../../../core/store/shared/shared.state';
import {SidebarSize} from '../../../core/models/sidebar-size';
import {TranslateService} from '@ngx-translate/core';
import {SVGItems, svgNames} from '../svg/svgItems';
import {EnvService} from '../../../models/env.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Select(SharedState.isDarkTheme) isDarkTheme$: Observable<boolean>;
  @Select(SharedState.sidebarSize) sidebarSize$: Observable<SidebarSize>;

  @Input()
  version: string;

  SVG_NAMES: SVGItems = svgNames;
  public SidebarSize = SidebarSize;
  showLightModeToggle: boolean = false;
  private destroy$ = new Subject<boolean>();

  constructor(
    private readonly store: Store,
    private login: LoginService,
    public translate: TranslateService,
    private envProvider: EnvService
  ) {}

  ngOnInit(): void {
    this.showLightModeToggle = this.envProvider.environment.showLightModeToggle;
    this.isDarkTheme$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isDarkTheme => {
        document.body.className = isDarkTheme ? 'dark-theme dark-mode' : 'dark-theme light-mode';
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public logoutUser() {
    this.login.logoutUser();
  }

  public toggleDarkTheme(value: boolean) {
    this.store.dispatch(new ToggleAppTheme(value));
  }

  public toggleSidebar() {
    this.store.dispatch(new ToggleSidebar());
  }
}
